import { Mousewheel } from 'swiper/modules'

export const SWIPER_SETTING = {
  mousewheel: {
    enabled: true,
    forceToAxis: true,
  },
  modules: [Mousewheel],
}
